module.exports = __webpack_public_path__ + "static/media/Banner-webshoppers-custom2020.199290c4.199290c4.jpg";